// extracted by mini-css-extract-plugin
module.exports = {"footer-header":"styles_footer-header__3_jM5","text-block":"styles_text-block__7Sfcd","heading-text":"styles_heading-text__YkhmI","normal-text":"styles_normal-text__Rg_J2"};